module.exports = __webpack_public_path__ + "img/zcbg.4b588d5a.png";